import { render, staticRenderFns } from "./Vehiculo.vue?vue&type=template&id=156ebdda&scoped=true"
import script from "./Vehiculo.vue?vue&type=script&lang=js"
export * from "./Vehiculo.vue?vue&type=script&lang=js"
import style0 from "./Vehiculo.vue?vue&type=style&index=0&id=156ebdda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ebdda",
  null
  
)

export default component.exports